"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Car;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Car(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "79",
    height: "39",
    viewBox: "0 0 79 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Group 839"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector",
    d: "M68.6508 30.7011L72.029 30.8257H72.8891C75.0083 30.8257 78 29.1196 78 27.0025L76.9155 23.0424L75.27 21.7223L76.2299 19.8045C76.3685 18.9952 76.2104 18.1631 75.7845 17.4608C75.3586 16.7586 74.6935 16.2332 73.9113 15.9813C73.9113 15.9813 63.9388 11.2865 53.9663 11.2865C51.0494 8.70862 45.6642 4.01369 40.5035 1.92153C39.3146 1.44801 38.0434 1.2152 36.7638 1.23662L11.4711 1C9.05277 1 2.47093 11.2865 2.47093 11.2865L2.24656 20.0909L1 21.7223V26.5916C1 27.7145 1.44651 28.7915 2.24135 29.5855C3.03618 30.3796 4.11423 30.8257 5.2383 30.8257L8.47936 31",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_2",
    d: "M23 31H45",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_3",
    d: "M3 12H54",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_4",
    d: "M16 38C19.866 38 23 34.866 23 31C23 27.134 19.866 24 16 24C12.134 24 9 27.134 9 31C9 34.866 12.134 38 16 38Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_5",
    d: "M62 38C65.866 38 69 34.866 69 31C69 27.134 65.866 24 62 24C58.134 24 55 27.134 55 31C55 34.866 58.134 38 62 38Z",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_6",
    d: "M18 2V12",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_7",
    d: "M14 2L12 12",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_8",
    d: "M33 2V12",
    stroke: "#002E6D",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Vector_9",
    d: "M49 31C49 31.5263 48.8963 32.0474 48.6948 32.5335C48.4933 33.0196 48.1981 33.4611 47.8259 33.8327C47.4538 34.2043 47.012 34.4987 46.5261 34.699C46.0401 34.8993 45.5194 35.0016 44.9939 35C44.4694 35 43.9501 34.8965 43.4655 34.6954C42.9809 34.4944 42.5407 34.1998 42.1698 33.8284C41.7989 33.457 41.5048 33.016 41.304 32.5307C41.1033 32.0454 41 31.5252 41 31C41 30.4747 41.1033 29.9545 41.304 29.4692C41.5048 28.9839 41.7989 28.543 42.1698 28.1716C42.5407 27.8002 42.9809 27.5055 43.4655 27.3045C43.9501 27.1035 44.4694 27 44.9939 27C45.5194 26.9984 46.0401 27.1007 46.5261 27.301C47.012 27.5013 47.4538 27.7957 47.8259 28.1673C48.1981 28.5389 48.4933 28.9803 48.6948 29.4664C48.8963 29.9525 49 30.4737 49 31",
    fill: "#54C8E8"
  })));
}